import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { headerStyles } from './style'

const PageTitleCS = (props) => {
  const classes = headerStyles()

  const heading = 'Application Tracker'

  return (
    <Box className={classes.programHeaderBar}>
      <Box className={classes.programDetailsDynamic}>
        <Typography className={classes.programTitle}>{heading}</Typography>
      </Box>
    </Box>
  )
}

export default PageTitleCS
